import React from 'react';
import { Button } from '@components/main-components/button/Button';
import { BridgeModal } from '@components/modals/Bridge';
import { SendFundsModal } from '@components/modals/SendFunds/SendFundsModal';
import { ModalContext, ModalType } from '@context/modal';
import { useHeaderStore } from '@store/header';
import { BalanceTrigger } from './BalanceTrigger';

export const WalletBalance = ({ variant }: { variant: 'desktop' | 'mobile' }) => {
  const { openModal } = ModalContext.useContainer();
  const { close } = useHeaderStore();

  return (
    <div className="flex w-full flex-col gap-2">
      <BalanceTrigger variant={variant} />
      <div className="flex pb-3 max-md:gap-4 md:gap-2 md:px-2">
        <div className="flex-1">
          <Button
            label="Bridge"
            size="S"
            variant="tertiary"
            fullWidth
            onClick={() => {
              // we want to close the header trigger before opening the modal
              close();

              // Need to defer the modal opening to the next tick to avoid
              // issue where the dropdown menu is still open
              // If we don't wait then it can cause the issue when we close the modal
              // to make the full screen not-clickable
              setTimeout(() => {
                openModal(ModalType.BRIDGE_MODAL, {
                  body: <BridgeModal />,
                });
              }, 0);
            }}
          />
        </div>
        <div className="flex-1">
          <Button
            label="Send"
            size="S"
            variant="tertiary"
            fullWidth
            onClick={() => {
              // we want to close the header trigger before opening the modal
              close();

              // Need to defer the modal opening to the next tick to avoid
              // issue where the dropdown menu is still open
              // If we don't wait then it can cause the issue when we close the modal
              // to make the full screen not-clickable
              setTimeout(() => {
                openModal(ModalType.SEND_FUNDS_MODAL, {
                  body: <SendFundsModal />,
                });
              }, 0);
            }}
          />
        </div>
      </div>
    </div>
  );
};
